// @ts-ignore
import { useOverflow } from 'react-overflow-indicator';
import { HiMiniChevronDown } from 'react-icons/hi2';

import { cn } from '@/lib/utils';

const SCROLL_AMOUNT = 400;

type ScrollIndicatorProps = {
  questionnaireLoading?: boolean;
};

export const ScrollIndicator = ({
  questionnaireLoading,
}: ScrollIndicatorProps) => {
  const { state, refs } = useOverflow();

  const cannotScroll = !state.canScroll.down && !state.canScroll.up;

  const shouldShow = state.canScroll.down && !questionnaireLoading;
  const shouldFadeOut =
    !state.canScroll.down && state.canScroll.up && !questionnaireLoading;
  const shouldHide = cannotScroll || questionnaireLoading;

  const onClickScrollDown = () => {
    refs.viewport.current?.scrollBy({
      top: SCROLL_AMOUNT,
      behavior: 'smooth',
    });
  };

  return (
    <div
      className={cn(
        'absolute bottom-0 -right-18 pr-10 mb-6 transform transition-all duration-200 ease-out',
        {
          'opacity-0 duration-0 transform-none invisible pointer-events-none':
            shouldHide,
          'delay-0 opacity-0 -translate-y-6': shouldFadeOut,
          'delay-100 opacity-100 translate-y-6': shouldShow,
        },
      )}
    >
      <button
        onClick={onClickScrollDown}
        className="bg-white rounded-full p-1 shadow-[0_2px_5px_rgba(40,40,48,0.2)] hover:shadow-[0_2px_7px_rgba(40,40,48,0.3)] transition-shadow cursor-pointer"
        aria-label="Défiler vers le bas"
      >
        <HiMiniChevronDown size={30} strokeWidth={0.2} />
      </button>
    </div>
  );
};
